import { render } from "./order-summary.vue?vue&type=template&id=79124ce5&scoped=true"
import script from "./order-summary.vue?vue&type=script&lang=js"
export * from "./order-summary.vue?vue&type=script&lang=js"

import "./order-summary.vue?vue&type=style&index=0&id=79124ce5&scoped=true&lang=css"

import exportComponent from "D:\\Development\\VSTS.Git\\FleuristeBergeron\\Spec_2.0\\Solutions\\WWW\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79124ce5"]])

export default __exports__